import { Button } from "@/components/button";
import HomeTheme from "@/assets/theme_1/home.svg";

import "./styles.scss";
import { FEATURES } from "./constants";
import { useTracking } from "@/hooks/useTracking";
import { useTrackAccessSection } from "@/hooks/useTrackAccessSection";

export const Hero = () => {
  const { sendEvent } = useTracking();

  useTrackAccessSection(".hero", "hero");

  const handleClickCtaButton = () => {
    window.location.href = "#next-level-step-1";

    sendEvent("button_clicked", {
      event_category: "hero_section",
      event_label: "Montagem do app",
      event_action: "click",
      value: 1,
    });
  };

  return (
    <div className="hero">
      <div className="hero__wrapper">
        <div className="hero__wrapper--content">

          <h1 className="hero__wrapper--content__title">
            Seu{" "}
            <span className="hero__wrapper--content__title--highlight">
              Provedor de internet
            </span>
            {" "}com um App Personalizado na Play Store e Apple Store
          </h1>

          <ul className="hero__wrapper--content__features">
            {FEATURES.map((feature, index) => {
              return (
                <li key={index} className="hero__wrapper--content__features--item">
                  <i className='bx  bx-check'></i>
                  <span>{feature}</span>
                </li>
              )
            })}
          </ul>

          <Button theme="primary" size="small" onClick={handleClickCtaButton}>
            Monte seu app agora mesmo
          </Button>
        </div>

        <div className="hero__wrapper--illustration">
          <img src={HomeTheme} alt="Home Theme" />
        </div>
      </div>
    </div>
  );
};
